module.exports = __webpack_public_path__ + "img/13.20419466.png";